import { DateRangePicker, defaultTheme, NumberField } from '@adobe/react-spectrum';
import { today, parseDate } from '@internationalized/date';
import React, { useState } from 'react'
import { Provider } from "@adobe/react-spectrum";

export default function BookRoom() {
  const todayPT = today('America/Los_Angeles')
  const startDate = parseDate('2025-08-11') > todayPT ? parseDate('2025-08-11') : todayPT;
  const [dates, setDates] = useState({
    start: startDate,
    end: startDate.add({ days: 1 })
  });
  // let [rooms, setRooms] = useState(1);
  let [adults, setAdults] = useState(1);
  return (

    <div className={`relative print:hidden border-t border-t-green-50 bg-light-gray`}>
      <div className="px-6 sm:px-8 mx-auto xl:container py-5 lg:py-3">
        <div className="text-center flex items-center justify-center flex-col lg:flex-row lg:divide-x lg:-mx-6 xl:-mx-9 divide-green-50">
          <p className="font-bold sm:text-lg text-purple-900 lg:px-6 xl:px-9 flex-shrink">
            Reservations Are Now Open!
          </p>
          <Provider theme={defaultTheme} colorScheme='light'>

            <div className='flex flex-wrap sm:flex-nowrap justify-center gap-x-4 gap-y-2 bg-light-gray lg:px-6 xl:px-9'>

              <DateRangePicker
                label="Trip Dates"
                value={dates}
                minValue={startDate}
                minDuration={1}
                width="16rem"
                validate={(range) =>
                  range?.end.compare(range.start) < 1
                    ? 'Check-out date must be after check-in date'
                    : null}
                onChange={setDates}
                isRequired={true}
                necessityIndicator="none" />

              <NumberField
                label="Guests per room"
                value={adults}
                onChange={setAdults}
                minValue={1}
                maxValue={4}
                validationBehavior="native"
                width="size-1200"
                isRequired={true}
                necessityIndicator="none"
              />
              {/* <NumberField
                label="Rooms"
                value={rooms}
                onChange={setRooms}
                minValue={1}
                maxValue={5}
                validationBehavior="native"
                width="size-1200"
                isRequired={true}
                necessityIndicator="none"
              /> */}
            </div>
          </Provider>
          <div className='mt-4 lg:mt-0 lg:px-6 xl:px-9 flex-shrink-0'><a href={
            `https://res.windsurfercrs.com/ibe/index.aspx?hotelID=17697&lang=en-us${dates?.start ? `&checkIn=${formatDateForShr(dates.start)}` : ""}${dates?.end ? `&checkOut=${formatDateForShr(dates.end)}` : ""}&adults=${adults || "1"}`
          } target="_blank" rel="noreferrer" className='btn btn-ruby'>Book a Room</a></div>
        </div>

      </div>
    </div>

  )
}

function formatDateForShr(date) {
  if (!date) return "";
  const month = date.month.toString().padStart(2, '0');
  const day = date.day.toString().padStart(2, '0');
  const year = date.year;
  return `${month}/${day}/${year}`;
}